export const selectPipeline = ({ pipeline }) => pipeline
export const selectIsPipelineLoading = ({ pipeline: { isLoading } }) => isLoading
